import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import FlashcardItem from "./FlashcardItem";
import "./FlashcardReview.css";

export default function FlashcardReview({ flashcards, onStatusChange, onSessionEnd, onExitPractice }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [flashcards]);

  const handleNext = () => {
    if (index + 1 >= flashcards.length) {
      onSessionEnd();
    } else {
      setIndex(i => i + 1);
    }
  };

  const handleStatusChange = (card, status, difficulty) => {
    onStatusChange(card, status, difficulty);
    handleNext();
  };

  const card = flashcards[index];
  if (!card)
    return (
      <div className="empty-review-container">
        <div className="empty-review-message">
          <h2>Você ainda não tem flashcards aqui.</h2>
            <p>
              Para criar novos flashcards, leia uma história, toque em uma palavra
              que você não conhece e salve. As palavras salvas vão aparecer aqui
              para você revisar.
            </p>

        </div>
  
        <button className="empty-review-exit-btn" onClick={onExitPractice}>
          Voltar
        </button>
      </div>
    );
  

  return (
    <div className="flashcard-review-container">
      
      <div className="story-back-row-flashcard">
        <div className="flashcard-back-btn" onClick={onExitPractice}>
          <FaArrowLeft size={14} />
          <span>Voltar</span>
        </div>
        <span className="flashcard-counter">{index + 1} de {flashcards.length}</span>
      </div>
      {/* === SESSION PROGRESS BARS === */}
      <div className="session-progress-bars">
        {flashcards.map((_, i) => (
          <div
            key={i}
            className={
              i < index
                ? "session-bar done"
                : i === index
                ? "session-bar active"
                : "session-bar"
            }
          />
        ))}
      </div>

      <FlashcardItem card={card} onStatusChange={handleStatusChange} />
    </div>
  );
}
